import React, { Children } from 'react'
import { Bounced } from 'components/atoms'
import {
  HazmatIcon,
  ContractFilledIcon,
  BackupOutlinedIcon,
  HotIcon,
  BackhaulIcon,
  RolledIcon,
  MustGoIcon,
  SameDaySpotIcon,
} from 'transfix-icons'
import { Tooltip } from 'transfix-ui'
import { EquipmentTypeIcon } from 'utils/equipment'
import { DEFAULT_DROP_TRAILER } from 'constants/equipment'

export interface IShipmentStatusIcons {
  dropTrailer?: boolean | null
  dropTrailerStops?: string | number
  shipperRateType?: string | null
  hot?: boolean | null
  rolloverCount?: number
  bouncedCount?: number
  hasHazmat?: boolean | null
  hasBackhaulEligibleLane?: boolean | null
  mustGo?: boolean
  sameDaySpot?: boolean
}

const ShipmentStatusIcons = ({ status }: { status: IShipmentStatusIcons }) => {
  const {
    bouncedCount = 0,
    dropTrailer,
    dropTrailerStops,
    hasBackhaulEligibleLane,
    hasHazmat,
    hot,
    mustGo,
    rolloverCount = 0,
    sameDaySpot,
    shipperRateType,
  } = status

  const icons = [
    hasHazmat && (
      <Tooltip
        position='bottom'
        id='hazmat'
        trigger={
          <span>
            <HazmatIcon />
          </span>
        }>
        Hazmat
      </Tooltip>
    ),
    shipperRateType === 'contract_primary' && (
      <Tooltip
        position='bottom'
        id='contract'
        trigger={
          <span>
            <ContractFilledIcon size='large' color='coolGray5' />
          </span>
        }>
        Contract
      </Tooltip>
    ),
    shipperRateType === 'contract_backup' && (
      <Tooltip
        position='bottom'
        id='backup'
        trigger={
          <span>
            <BackupOutlinedIcon size='large' color='coolGray5' />
          </span>
        }>
        Backup
      </Tooltip>
    ),
    hot && (
      <Tooltip
        position='bottom'
        id='hot'
        trigger={
          <span>
            <HotIcon size='large' />
          </span>
        }>
        Hot
      </Tooltip>
    ),
    sameDaySpot && (
      <Tooltip
        position='bottom'
        id='same-day-spot'
        trigger={
          <span>
            <SameDaySpotIcon size='large' color='coolGray5' />
          </span>
        }>
        Same Day Spot
      </Tooltip>
    ),
    hasBackhaulEligibleLane && (
      <Tooltip
        position='bottom'
        id='backHaul'
        trigger={
          <span>
            <BackhaulIcon size='large' />
          </span>
        }>
        Backhaul Eligible
      </Tooltip>
    ),
    rolloverCount > 0 && (
      <Tooltip
        position='bottom'
        id='rollover'
        trigger={
          <span>
            <RolledIcon size='large' color='error' />
          </span>
        }>
        Rolled {rolloverCount}x
      </Tooltip>
    ),
    bouncedCount > 0 && (
      <Bounced
        className='large icon-error'
        count={bouncedCount}
        tooltipAlign='bottom'
        minWidth='24'
      />
    ),
    dropTrailer && (
      <EquipmentTypeIcon
        className='icon large icon-secondary'
        icon={DEFAULT_DROP_TRAILER.icon}
        tooltip={`Drop Trailer (${dropTrailerStops})`}
        tooltipAlign='bottom'
      />
    ),
    mustGo && <MustGoIcon color='error' className='icon-special' size='large' />,
  ].filter(Boolean)
  return (
    <>
      {Children.map(icons, icon => (
        <div className='mr2' data-test='status-icon'>
          {icon}
        </div>
      ))}
    </>
  )
}

export default ShipmentStatusIcons
